document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector(".new-header");
  const video = document.querySelector(".ts-background-video--video");

  if (header && video) {
    const adjustVideoMargin = () => {
      video.style.marginTop = -header.offsetHeight + "px";
    };

    adjustVideoMargin();

    window.addEventListener("resize", adjustVideoMargin);
  }
});
